'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirportShuttle = function MdAirportShuttle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 18.4h8.4l-6.8-6.8h-1.6v6.8z m4.1 10.7c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m-7.5-10.7v-6.8h-6.6v6.8h6.6z m-11.6 10.7c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m-5-10.7h6.6v-6.8h-6.6v6.8z m23.4-10l10 10v8.2h-4.3c0 2.8-2.2 5-5 5s-5-2.2-5-5h-9.1c0 2.8-2.3 5-5 5s-5-2.2-5-5h-3.4v-15c0-1.8 1.6-3.2 3.4-3.2h23.4z' })
        )
    );
};

exports.default = MdAirportShuttle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airport-shuttle.js
// module id = 457
// module chunks = 0